import BreListGroup from './BreListGroup';

const VERY_LOW_PRIORITY = 100;

/**
 * Properties-panel provider that adds a "Business Rule Exceptions" group listing
 * every BRE described in the diagram, with its description and the process
 * events that use it.
 */
export default class BreListProvider {
  constructor(propertiesPanel, injector) {
    propertiesPanel.registerProvider(VERY_LOW_PRIORITY, this);
    this._injector = injector;
  }

  getGroups(element) {
    return (groups) => {
      // Das ausgewaehlte Element geht mit: an einem Ereignis bietet die Gruppe
      // zusaetzlich an, es als Ausloeser einer Ausnahme zu setzen.
      const group = BreListGroup(this._injector, element);
      if (group) {
        groups.push(group);
      }
      return groups;
    };
  }
}

BreListProvider.$inject = ['propertiesPanel', 'injector'];
